import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-generate-glossary',
  templateUrl: './generate-glossary.component.html',
  styleUrls: ['./generate-glossary.component.scss']
})

export class GenerateGlossaryComponent implements OnInit, AfterViewInit, OnDestroy {

	userID = 0
	courseID = 0
	courseUnits: any[] = []
	selectedUnit = -1
	searchTerm = ""
	reset = false
	wordList: any[] = []
	selectedWords: any[] = []

	searching = false
	glossaryLoading = false
	glossarySuccess = false
	glossaryError = false

	showCourseSub = new Subscription
	wikiSub = new Subscription
	definitionSub = new Subscription
	generateGlossarySub = new Subscription

	constructor(private dataService: ApiService, private actRoute: ActivatedRoute, private router: Router) { }

	ngOnInit() {
		this.userID = this.dataService.getUserID()
		this.courseID = +this.actRoute.snapshot.paramMap.get('id')!
		
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units
			},
			error => {
				console.log(error)
			},
		)
	}

	ngAfterViewInit() {}

	ngOnDestroy() {
		this.showCourseSub?.unsubscribe()
		this.wikiSub?.unsubscribe()
		this.definitionSub?.unsubscribe()
		this.generateGlossarySub?.unsubscribe()
	}

	glossarySearch() {
		if (this.searchTerm === undefined || this.searchTerm === "") {
			alert("Por favor, escriba un término de búsqueda.")
			return;
		}

		this.searching = true
		this.wikiSub = this.dataService.wikipediaWordList(this.searchTerm)
		.subscribe(
			async data => {
				// console.log(data)
				this.wordList = []
				let words = data[1]
				let num = words.length - 1;
				for (let i = 0; i <= num; i++) {
					let word = words[i]
					let definition = ''
					
					await this.dataService.wikipediaWordDefinition(word)
					.toPromise().then(
						data => {
							let pages = data.query.pages
							definition = pages[+Object.keys(pages)].extract
							definition = definition.trim().replace(/ *\[[^\]]*]/g, '')
						},
						_error => {
							// console.log(error)
						}
					);

					let wordObj = {
						'word': word,
						'definition': definition,
					};

					if (this.wordIndexInGlossary(wordObj) === -1 && word.toLowerCase() === this.searchTerm.toLowerCase()) {
						this.glossaryList(wordObj)
					}

					this.wordList.push(wordObj)
					// console.log(word)
					// console.log(definition)
				}
				// console.log(words)
				// console.log(links)
				// console.log(this.wordList)
				this.searching = false
			},
			_error => {
				// console.log(error)
				this.searching = false
			},
		);
	}

	wordIndexInGlossary(word: any) {
		let index = this.selectedWords.findIndex((wordInList) => {
			return word.word.toLowerCase() === wordInList.word.toLowerCase()
		})

		return index
	}

	glossaryList(word: any) {
		let index = this.wordIndexInGlossary(word)

		if (index > -1) {
			this.selectedWords.splice(index, 1)
		} else {
			this.selectedWords.push(word)
		}
	}

	showDefinition(word: any) {
		alert(word.definition)
	}

	clear() {
		this.selectedWords = []
	}

	generateGlossary() {
		this.glossaryLoading = true
		// console.log(this.selectedWords)
		// console.log(this.selectedUnit)
		// console.log(this.reset)

		this.generateGlossarySub = this.dataService.generateGlossary(this.selectedWords, this.selectedUnit, this.reset)
		.subscribe(
			_data => {
				// console.log(data)
				this.glossaryLoading = false
				this.glossarySuccess = true
				this.glossaryError = false

				setTimeout(() => {
					this.router.navigate(['course', this.courseID])
				}, 2 * 1000)
			},
			_error => {
				// console.log(error)
				this.glossaryLoading = false
				this.glossarySuccess = false
				this.glossaryError = true
			},
		)
	}

}